export const NEW_GRADE = "NEW"
export const LEAVING_GRADE = "LEAVING"
